exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".property-pair{margin-left:24px;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-items:center;padding-bottom:10px;-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.property-key{flex-basis:140px}.property-key,.property-value{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.property-value{flex-basis:300px;padding-left:20px}", ""]);

// exports
